var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pt-3" },
    [
      _c(
        "v-card",
        { staticClass: "pa-0 ma-0", attrs: { tile: "", elevation: "0" } },
        [
          _c(
            "v-card-title",
            { staticClass: "pa-0 ma-0" },
            [
              _vm.searchable
                ? _c("FormsTextField", {
                    style:
                      _setup.breakpoint().name === "xs"
                        ? "width: 100%"
                        : "width: 30%",
                    attrs: {
                      label: "Pesquisar",
                      "append-icon": "mdi-magnify",
                      outlined: "",
                      dense: "",
                      placeholder: "Comece a digitar para pesquisar",
                    },
                    model: {
                      value: _setup.textSearch,
                      callback: function ($$v) {
                        _setup.textSearch = $$v
                      },
                      expression: "textSearch",
                    },
                  })
                : _vm._e(),
              _c("v-spacer"),
              _vm.showReload
                ? _c("emc-table-icon", {
                    attrs: {
                      loading: _setup.isLoading,
                      icon: "mdi-refresh",
                      color: "success",
                      "tool-tip": "Atualizar",
                    },
                    on: {
                      click: function ($event) {
                        return _setup.reloadData()
                      },
                    },
                  })
                : _vm._e(),
              _vm._t("tools"),
            ],
            2
          ),
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _setup.headersItems,
          items: _setup.collection,
          options: _setup.options,
          "server-items-length": _setup.meta.total,
          page: _setup.meta.page,
          "items-per-page": _setup.options.itemsPerPage,
          "footer-props": _setup.footerProps,
          loading: _setup.isLoading,
          "no-data-text":
            _setup.textSearch || !_vm.searchable
              ? `Nenhum resultado encontrado`
              : `Faça uma pesquisa para visualizar os dados...`,
          "loading-text": "Carregando...",
        },
        on: {
          "update:options": function ($event) {
            _setup.options = $event
          },
          "update:page": function ($event) {
            return _vm.$set(_setup.meta, "page", $event)
          },
        },
        scopedSlots: _vm._u(
          [
            _vm._l(Object.keys(_vm.$scopedSlots), function (slot) {
              return {
                key: slot,
                fn: function (scope) {
                  return [_vm._t(slot, null, null, scope)]
                },
              }
            }),
            _vm._l(_setup.headerItemsTypes, function (header, index) {
              return {
                key: `item.${header.value}`,
                fn: function ({ item }) {
                  return [
                    _c("TablesPartFormatItem", {
                      key: index,
                      attrs: { header: header, item: item },
                    }),
                  ]
                },
              }
            }),
            {
              key: "item.actions",
              fn: function ({ item }) {
                return [
                  _c("tables-part-actions", {
                    attrs: {
                      "no-default-actions": _vm.noDefaultActions,
                      "hide-btn-edit": _vm.hideBtnEdit,
                      "hide-btn-delete": _vm.hideBtnDelete,
                    },
                    on: {
                      clickedEditButton: function ($event) {
                        return _setup.edit(item)
                      },
                      clickedDeleteButton: function ($event) {
                        return _setup.confirmation(item)
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "actions",
                          fn: function () {
                            return [_vm._t("actions", null, { item: item })]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ]
              },
            },
            {
              key: "item.active",
              fn: function ({ item }) {
                return [_c("TablesPartActive", { attrs: { item: item } })]
              },
            },
            _vm.onlyActive
              ? {
                  key: "footer.prepend",
                  fn: function () {
                    return [
                      _c(
                        "v-row",
                        [
                          _c("FormsSwitch", {
                            staticClass: "ml-3",
                            attrs: {
                              sm: "3",
                              label: "Exibir apenas itens ativos",
                            },
                            model: {
                              value: _setup.filterIsActive,
                              callback: function ($$v) {
                                _setup.filterIsActive = $$v
                              },
                              expression: "filterIsActive",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      }),
      _c("DialogsConfirmation", {
        attrs: {
          show: _setup.showConfirmation,
          message: "Tem certeza que deseja excluir?",
          loading: _setup.isLoading,
        },
        on: {
          "update:show": function ($event) {
            _setup.showConfirmation = $event
          },
          confirm: _setup.deleteItem,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }